import React, { useState } from "react";
import { Modal, Input, message } from "antd";
import { disableTopic } from "../../../services/polly/classificationService";

const { TextArea } = Input;

export default function DisableModal({ visible, topic, onCancel, onSuccess }) {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const handleDisable = async () => {
    setLoading(true);
    try {
      await disableTopic(topic.id);
      setReason("");
      onSuccess();
    } catch (err) {
      console.warn("Failed to disable topic:", err);
      message.error("Failed to disable topic");
    }
    setLoading(false);
  };

  const handleCancel = () => {
    setReason("");
    onCancel();
  };

  if (!topic) return null;

  const subtopicCount = topic.children ? topic.children.length : 0;

  return (
    <Modal
      title="Disable Topic"
      visible={visible}
      onOk={handleDisable}
      onCancel={handleCancel}
      okText="Disable"
      okButtonProps={{ danger: true, loading: loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      <div className="disable-warning">
        Disabling <strong>{topic.name}</strong> will stop Polly from classifying
        new conversations here. Existing classifications are not affected.
      </div>
      <ul className="disable-impact-list">
        <li>Topic disappears from the active classification tree</li>
        <li>New conversations fall to parent or General Inquiry</li>
        <li>
          {topic.conversationCount || 0} existing conversation
          {topic.conversationCount !== 1 ? "s" : ""} remain tagged and visible
        </li>
        {subtopicCount > 0 && (
          <li>
            Subtopics ({subtopicCount}) also disabled automatically
          </li>
        )}
        <li>Can be re-enabled at any time</li>
      </ul>
      <TextArea
        placeholder="Reason for disabling (optional)"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        rows={3}
        disabled={loading}
      />
    </Modal>
  );
}
